/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_Outlook_Connected_DescriptionInputs */



/**
* | output |
* | --- |
* | "Mailboxes you've enabled for the assistant to read, send, and manage mail and calendar events." |
*
* @param {Connections_Outlook_Connected_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const connections_outlook_connected_description = /** @type {((inputs?: Connections_Outlook_Connected_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_Outlook_Connected_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Postfächer, die Sie für den Assistenten aktiviert haben, um E-Mails und Kalendereinträge zu lesen, zu senden und zu verwalten.")
	return /** @type {LocalizedString} */ ("Mailboxes you've enabled for the assistant to read, send, and manage mail and calendar events.")
});